// Route Your Career — Italy Course Database
// Generated from the uploaded BACHELORS + MASTERS workbook.
// Keep this file at:
// frontend/src/data/italyCourses.js

export const italyBachelors = [
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Applied Computer Science and Artificial Intelligence"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Sustainable Building Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Classics"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Global Humanities"
  },
  {
    "university": "University of Macerata",
    "level": "Bachelor",
    "course": "International, European and Comparative Legal Studies"
  },
  {
    "university": "University of Pavia",
    "level": "Bachelor",
    "course": "Artificial Intelligence"
  },
  {
    "university": "University of Turin",
    "level": "Bachelor",
    "course": "Business & Management"
  },
  {
    "university": "University of Turin",
    "level": "Bachelor",
    "course": "Global Law and Transnational Legal Studies"
  },
  {
    "university": "University of Pisa",
    "level": "Bachelor",
    "course": "Management for Business and Economics"
  },
  {
    "university": "University of Camerino",
    "level": "Bachelor",
    "course": "Biosciences and Biotechnology"
  },
  {
    "university": "University of Tor vergata",
    "level": "Bachelor",
    "course": "Business Administration & Economics 2 curriculum- Economics and Business Administration"
  },
  {
    "university": "University of Tor vergata",
    "level": "Bachelor",
    "course": "Global Governance"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "ELECTRONIC AND COMMUNICATIONS ENGINEERING"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "Architecture"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "Automotive Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "Mechanical Engineering"
  },
  {
    "university": "University of Cassino",
    "level": "Bachelor",
    "course": "Economics with Data Science"
  },
  {
    "university": "University of Cassino",
    "level": "Bachelor",
    "course": "Economics and Business"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Data Analysis"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Political Sciences and International Relations"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Marine Biology and Blue Biotechnologies"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Transnational and European Legal Studies"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Business Management"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Civil Engineering"
  },
  {
    "university": "University of Milan",
    "level": "Bachelor",
    "course": "International Politics, Law and Economics"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Business Administration and Management"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Digital Management"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Economics & Business-Curriculam Economics, Markets & Finance"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Hospitality Innovation and e-Tourism"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Philosophy, International and Economic Studies"
  },
  {
    "university": "University of Marche",
    "level": "Bachelor",
    "course": "Digital Economics and Business"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Bachelor",
    "course": "Hospitality Management"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Building Construction Engineering"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Business and Economics- CLABE (Bologna Campus)"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Business Economics- Curriculum Financial and Business Management (Rimini Campus)"
  },
  {
    "university": "University of Tor vergata",
    "level": "Bachelor",
    "course": "Engineering Science"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Economics and Finance"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Economics of Tourism and Cities (old name: Economics of Tourism curriculum- International Tourism and Leisure Industries)"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Economics, Politics and Social Sciences"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Genomics (Bologna)"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "International Studies"
  },
  {
    "university": "University of Polito",
    "level": "Bachelor",
    "course": "Civil and Environmental Engineering"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Management and Economics- CLAME (Forlì Campus)"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Pharmacy (Rimini)"
  },
  {
    "university": "University of Bologna",
    "level": "Bachelor",
    "course": "Statistical Sciences Curriculum Stats & Maths"
  },
  {
    "university": "University of Campania",
    "level": "Bachelor",
    "course": "Data Analytics"
  },
  {
    "university": "University of Cassino",
    "level": "Bachelor",
    "course": "Industrial Engineering Technology"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Earth and Climate Dynamics"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Animal Care"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Biology of Human and Environmental Health"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Information Engineering"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Psychological Science"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Molecular Biology, Medicinal Chemistry and Computer Science for Pharmaceutical Applications"
  },
  {
    "university": "University of Trieste",
    "level": "Bachelor",
    "course": "Business Administration and Managment curricula Business and Management"
  },
  {
    "university": "University of Trieste",
    "level": "Bachelor",
    "course": "International Economics and Financial Markets curricula Economics and Financial Markets"
  },
  {
    "university": "University of Milan",
    "level": "Bachelor",
    "course": "Ancient Civilizations for The Contemporary World"
  },
  {
    "university": "University of Florence",
    "level": "Bachelor",
    "course": "Sustainable Business for Societal Challenges"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Bachelor",
    "course": "Civil and Environmental Engineering"
  },
  {
    "university": "University of Pavia",
    "level": "Bachelor",
    "course": "Social Sciences for Global Challenges"
  },
  {
    "university": "University of Venice",
    "level": "Bachelor",
    "course": "Computer Science - Data Science Curriculum"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Business Sciences"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Economics and Finance"
  },
  {
    "university": "Free University of Bozen-Bolzano",
    "level": "Bachelor",
    "course": "All"
  },
  {
    "university": "University of Siena",
    "level": "Bachelor",
    "course": "Biotech Engineering for Health"
  },
  {
    "university": "University of Siena",
    "level": "Bachelor",
    "course": "Economics and Management"
  },
  {
    "university": "University Of Milano Bicocca",
    "level": "Bachelor",
    "course": "Physical Sciences for Advanced Technologies"
  },
  {
    "university": "University Of Milano Bicocca",
    "level": "Bachelor",
    "course": "Economics and Science for Environmental Sustainability"
  },
  {
    "university": "University of Parma",
    "level": "Bachelor",
    "course": "Global studies for sustainable local and international development and cooperation"
  },
  {
    "university": "University of Trento",
    "level": "Bachelor",
    "course": "Computer, Communications and Electronic Engineering"
  },
  {
    "university": "University of Trento",
    "level": "Bachelor",
    "course": "Computer Science"
  },
  {
    "university": "University of Turin",
    "level": "Bachelor",
    "course": "Economics and Finance with Data Science"
  },
  {
    "university": "University of Marche",
    "level": "Bachelor",
    "course": "Environmental Sciences and Civil Protection"
  },
  {
    "university": "University of NAPLES Parthenope",
    "level": "Bachelor",
    "course": "Business Economics"
  },
  {
    "university": "University of Perugia",
    "level": "Bachelor",
    "course": "Engineering management"
  },
  {
    "university": "University of Bari Aldo Moro",
    "level": "Bachelor",
    "course": "Earth System and Global Changes"
  },
  {
    "university": "University of Genova",
    "level": "Bachelor",
    "course": "Computer Engineering"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Bachelor",
    "course": "Biology for One-Health"
  },
  {
    "university": "University of Padova",
    "level": "Bachelor",
    "course": "Economics, Governance and Decision-Making Old Name - Philosophy, Politics and Economics"
  },
  {
    "university": "University of Sapienza",
    "level": "Bachelor",
    "course": "Bioinformatics"
  },
  {
    "university": "University of Tor vergata",
    "level": "Bachelor",
    "course": "TOURISM SCIENCES (curriculum in English Innovation Tourism for Made in Italy)"
  },
  {
    "university": "University of Polimi",
    "level": "Bachelor",
    "course": "Engineering Science"
  },
  {
    "university": "University of Polimi",
    "level": "Bachelor",
    "course": "Industrial Engineering"
  },
  {
    "university": "University of Polimi",
    "level": "Bachelor",
    "course": "Process Engineering"
  },
  {
    "university": "University of Polimi",
    "level": "Bachelor",
    "course": "Architecture"
  },
  {
    "university": "University of Genova",
    "level": "Bachelor",
    "course": "MARITIME SCIENCE AND TECHNOLOGY"
  },
  {
    "university": "University of Messina",
    "level": "Bachelor",
    "course": "Heritage Innovation Engineering"
  },
  {
    "university": "University of Cassino",
    "level": "Bachelor",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Trento",
    "level": "Bachelor",
    "course": "Economia and Management"
  },
  {
    "university": "University of Bocconi",
    "level": "Bachelor",
    "course": "Economics, Management and Computer Science"
  },
  {
    "university": "University of Teramo",
    "level": "Bachelor",
    "course": "Biotechnology"
  },
  {
    "university": "University of Cassino",
    "level": "Bachelor",
    "course": "Civil and Environmental Engineering"
  },
  {
    "university": "University of Polimi",
    "level": "Bachelor",
    "course": "Civil Engineering"
  },
  {
    "university": "University of Milan",
    "level": "Bachelor",
    "course": "Economics: Behavior, Data and Policy"
  }
];

export const italyMasters = [
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Artificial Intelligence and Robotics"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Business Management"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Chemical Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Control Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Data Science"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Economics and Communication for Management and Innovation"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Electrical Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Electronics Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Engineering in Computer Science"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Finance and Insurance"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Health Economics"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Management Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Nanotechnology Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Statistical Methods and Applications"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Architecture - Urban regeneration"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Architecture (Conservation)"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Atmospheric Science & Technology for Meteorology & Climate"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Biochemistry"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Cognitive Neuroscience"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Cultural Heritage in the Near and Middle East, and Africa"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Cybersecurity"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Design, Multimedia and Visual Communication"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Development and International Cooperation Sciences"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Energy Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "English and Anglo-American Studies"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Environmental Engineering for Climate Change Adaptation and Mitigation"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "European Studies"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Fashion Theory and Practices"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Genetics and Molecular Biology"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Landscape Architecture"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Mechanical Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Mediterranean Archeology"
  },
    {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Msc Environmental and Sustainable Building Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Product and Service Design"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Science and Technology for the Conservation of Cultural Heritage"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Space and Astronautical Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Transport Systems Engineering"
  },
  {
    "university": "University of Macerata",
    "level": "Master",
    "course": "International Finance and Economics"
  },
  {
    "university": "University of Macerata",
    "level": "Master",
    "course": "International Relations"
  },
  {
    "university": "University of Macerata",
    "level": "Master",
    "course": "International tourism and destination management"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Civil Engineering for Mitigation of Risk from Natural Hazards"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Electrical Engineering"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "World Politics and International Relations"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Electronic Engineering"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Industrial Automation Engineering"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Molecular Biology and Genetics"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "The Ancient Mediterranean World (History Archaeology and Art)"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Psychology, Neuroscience and Human Sciences"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "International Business and Entrepreneurship"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Applied Mathematics"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Artificial Intelligence and Automation Engineering"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Biodiversity, Conservation and Environmental Quality"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Biotechnologies of Human Reproduction"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Chemistry"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Electronics and Communications Engineering"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Engineering Management"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "European Studies"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Finance"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Genetic Counsellors"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "International Accounting and Management"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Language and Mind: Linguistics and cognitive studies"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Medical Biotechnologies"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Public and Cultural Diplomacy"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Business Administration"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "European Legal Studies"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Scienze animali (curriculum in Animal nutrition and feed safety) (Animal Science)"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Area and Global Studies for International Cooperation"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Cellular and Molecular Biology"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Quantitative Finance and Insurance"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Scienze viticole ed enologiche (International curriculum) (Viticulture and Enalogy Sciences)"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Material Sciences"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Molecular Biotechnology"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Filosofia (International curriculum) (Philosophy)"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Stochastics and Data Science"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "English and American Studies"
  },
  {
    "university": "University of Brescia",
    "level": "Master",
    "course": "Analytics and Data Science for Economics and Management"
  },
  {
    "university": "University of Brescia",
    "level": "Master",
    "course": "Civil and Environmental Engineering"
  },
  {
    "university": "University of Brescia",
    "level": "Master",
    "course": "Communication Technologies and Multimedia"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Advanced Cosmetic Sciences (Rimini)"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Aerospace Engineering"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Applied Economics and Markets"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Archaeology and Cultures of the Ancient World CURRICULUM in Applied Critical Archaeology and Heritage"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Architecture and Creative Practices for the City and Landscape"
  },
  {
    "university": "University of Venice",
    "level": "Master",
    "course": "Comparative International Relations"
  },
  {
    "university": "University of Bologna",
    "level": "Master",
    "course": "Astrophysics and Cosmology"
  },
  {
    "university": "University of Venice",
    "level": "Master",
    "course": "Computer Science and Information Technology"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Nuclear Engineering"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Artificial Intelligence and Data Engineering"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Cybersecurity"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Computer Science and Networking"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "BIONICS ENGINEERING"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Applied and Exploration Geophysics"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Materials and Nanotechnology"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Neuroscience"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Data Science and Business Informatics"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Biological Sciences"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Chemistry and Advanced Chemical Methodologies"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Geoenviromental Resources and Risks"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Mathematics and Appplications"
  },
  {
    "university": "University of Camerino",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "European Economy and Business Law"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Finance and Banking"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Mechatronics Engineering"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Sport and Health Promotion Old Name- Physical Activity and Health Promotion"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "ICT & Internet Engineering"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Art History in Rome, from Late Antiquity to the Present"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Tourism Strategy, Cultural Heritage and Made in Italy"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Business Administration"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "BIOTECHNOLOGY FOR INDUSTRY AND HEALTH"
  },
  {
    "university": "University of Venice",
    "level": "Master",
    "course": "Conservation Science and Technology for Cultural Heritage"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Advanced Molecular Sciences"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Architettura (curriculum \"Architectural design\")"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Design of Sustainable Tourism Systems"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Economics and Development"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Finance and risk management"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Geoengineering"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Geography, Spatial Management, Heritage for International Cooperation"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Mechanical Engineering for Sustainability"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Natural Resources Management for Tropical Rural Development"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Architecture Construction City"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Architecture for Sustainability"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Architecture for Heritage"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Urban and Territorial Planning"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "BUILDING ENGINEERING"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "DIGITAL SKILLS FOR SUSTAINABLE SOCIETAL TRANSITIONS"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Automotive Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Communications Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Data Science and Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "ICT Engineering for Smart Societies"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Civil Engineering."
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Electronic Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Energy and Nuclear Engineeing"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Management Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Mechanical Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Environmental and Land Engineering."
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Mechatronic Engineering"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Physics of Complex Systems"
  },
  {
    "university": "University of Siena",
    "level": "Master",
    "course": "Sustainable Industrial Pharmaceutical Biotechnology"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "International Management"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "Advanced Automotive Engineering The programme includes seven curricula: • Advanced Motorcycle Engineering • Advanced Powertrain- Bologna • Advanced Powertrain- Modena • Advanced Sportscar Manufacturing • High Performance Car Design • Off-Highway Vehicle Engineering • Racing Car Design (in collaboration with the Universities of Bologna, Ferrara, and Parma)"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "Sustainable Industrial Engineering"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "DIGITAL AUTOMATION ENGINEERING"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "Languages for Communication in International Enterprises and Organisations"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "Electronics Engineering"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Comparative European and Non-European Languages and Literatures"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Biology for Translational Research and Precision Medicine"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Computer Engineering for Intelligent Systems (old name: Computer Engineering for Robotics and Smart Industry)"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Artificial Intelligence"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Data Science"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Economics and Data Analysis"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "International Economics and Business"
  },
    {
    "university": "University of Verona",
    "level": "Master",
    "course": "International Economics and Business"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Mathematics"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Medical Bioinformatics"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Molecular and Medical Biotechnology"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Linguistics"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Applied Economics"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Astrophysics and Cosmology"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Biotechnologies for Food Science"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Business Administration"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Chemical and Process Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Computer Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Control Systems Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Cybersecurity"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Data Science"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Earth Dynamics"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Electronic Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Energy Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Environmental Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Food and Health"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Forest Science"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "ICT for Internet and Multimedia"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Management Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Materials Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Mathematical Engineering"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Medical Biotechnologies"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Molecular Biology"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Sustainable Agriculture"
  },
  {
    "university": "University of Padua",
    "level": "Master",
    "course": "Water and Geological Risk Engineering"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Bioinformatics for Computational Genomics"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Biotechnology for the Bioeconomy"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Data Science for Economics"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Environmental and Food Economics"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Environmental Change and Global Sustainability"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Finance and Economics"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Industrial Chemistry"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "International Relations"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Law and Sustainable Development"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Medical Biotechnology and Molecular Medicine"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Molecular Biology of the Cell"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Molecular Biotechnology and Bioinformatics"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Pharmaceutical Biotechnology"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Politics, Philosophy and Public Affairs"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Quantitative Biology"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Safety Assessment of Xenobiotics and Biotechnological Products"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Sustainable Development"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Artificial Intelligence Systems"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Cellular and Molecular Biotechnology"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Data Science"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Economics"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Environmental Engineering"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "European and International Studies"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Human-Computer Interaction"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Innovation Management"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "International Management"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Mathematics"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Mechatronics Engineering"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Quantitative and Computational Biology"
  },
  {
    "university": "University of Trento",
    "level": "Master",
    "course": "Sociology and Social Research"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Bioengineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Computer Science"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Energy Engineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Engineering for Natural Risk Management"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Environmental Engineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Internet and Multimedia Engineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Management Engineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Robotics Engineering"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Safety Engineering for Transport, Logistics and Production"
  },
  {
    "university": "University of Genoa",
    "level": "Master",
    "course": "Naval Architecture and Marine Engineering"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Communication Engineering"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Electronic Engineering"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Engineering for the Food Industry"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Environmental and Land Management Engineering"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Food Safety and Food Risk Management"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "International Business and Development"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Language Sciences and Cultural Studies for Special Needs"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Advanced Automotive Engineering"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Economics, Management and Policies for Global Challenges"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Physics"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Biotechnology for Human Health"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Green Economy and Sustainability"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Innovation Design"
  },
  {
    "university": "University of Ferrara",
    "level": "Master",
    "course": "Small Business Management in International Markets"
  },
  {
    "university": "University of Cassino",
    "level": "Master",
    "course": "Economics and Entrepreneurship"
  },
  {
    "university": "University of Modena",
    "level": "Master",
    "course": "ENERGY ENGINEERING"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Environmental Engineering for Risk Mitigation"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Functional and sustainable materials"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Advanced molecular sciences for health products"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Data science for management"
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Economics and Management of Sustainable Food System"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Master",
    "course": "Sustainable food systems"
  },
  {
    "university": "University of NAPLES Parthenope",
    "level": "Master",
    "course": "Marketing & International Management  (Two curriculum Innovation and the curriculum Entrepreneurship)"
  },
  {
    "university": "University of Marche",
    "level": "Master",
    "course": "Data science for Finance and Economics"
  },
  {
    "university": "University of Marche",
    "level": "Master",
    "course": "Environmental Hazard and Disaster Risk Management"
  },
  {
    "university": "University of Marche",
    "level": "Master",
    "course": "Marine Biology"
  },
  {
    "university": "University of Milan",
    "level": "Master",
    "course": "Cultural, Intellectual and Visual History"
  },
  {
    "university": "University of Eastern Piedmont",
    "level": "Master",
    "course": "Management and Finance curriculum in Finance"
  },
  {
    "university": "University of Eastern Piedmont",
    "level": "Master",
    "course": "Disaster and Health Crisis Management"
  },
  {
    "university": "University of Tor vergata",
    "level": "Master",
    "course": "Management Engineering (English curriculum in Technologies and New Frontiers Management)"
  },
  {
    "university": "University of NAPLES Parthenope",
    "level": "Master",
    "course": "Business Economics"
  },
  {
    "university": "University of NAPLES Parthenope",
    "level": "Master",
    "course": "Management Engineering"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Geology for energy resources"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Agricultural and environmental biotechnology"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Medical, veterinary and forensic biotechnological sciences"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Quantitative Finance And Data Science For Economics"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "International Relations (LM-52)"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Earth Sciences for Risk and Environmental Management (LM-74) Curriculum: Geosciences for Environmental Sustainability"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Administration, Finance and Control (LM-77) Curriculum: Accounting & Business administration"
  },
  {
    "university": "University of Perugia",
    "level": "Master",
    "course": "Economics And Management"
  },
  {
    "university": "Polytechnic University of Bari",
    "level": "Master",
    "course": "Automation Engineering"
  },
  {
    "university": "Polytechnic University of Bari",
    "level": "Master",
    "course": "Computer Science Engineering"
  },
  {
    "university": "Polytechnic University of Bari",
    "level": "Master",
    "course": "Telecommunication Engineering"
  },
  {
    "university": "Polytechnic University of Bari",
    "level": "Master",
    "course": "Industrial Design"
  },
  {
    "university": "Polytechnic University of Bari",
    "level": "Master",
    "course": "Mechanical Engineering"
  },
  {
    "university": "University of Tuscia",
    "level": "Master",
    "course": "Archival Science and Artificial Intelligence"
  },
  {
    "university": "University of Bari Aldo Moro",
    "level": "Master",
    "course": "Materials Science and Tecnology"
  },
  {
    "university": "University of Messina",
    "level": "Master",
    "course": "Quantitative Methods for Finance"
  },
  {
    "university": "University of Messina",
    "level": "Master",
    "course": "Civil Engineering (Curriculum in Engineering for Water-related Risks)"
  },
  {
    "university": "University of Messina",
    "level": "Master",
    "course": "Physics: Material Physics and Devices"
  },
  {
    "university": "University of Cassino",
    "level": "Master",
    "course": "Sport Management - Curriculum Sport Event Management"
  },
  {
    "university": "University of Pavia",
    "level": "Master",
    "course": "Geosciences for Sustainable Development Curriculum in Geosciences for Energy, Mineral and Water Resources"
  },
  {
    "university": "University of Polimi",
    "level": "Master",
    "course": "Computer Science and Engineering With Artificial Intelligence"
  },
  {
    "university": "University of Polimi",
    "level": "Master",
    "course": "Industrial Safety and Risk Engineering"
  },
  {
    "university": "University of Polimi",
    "level": "Master",
    "course": "Building Engineering for Sustainability"
  },
  {
    "university": "University Of Milano Bicocca",
    "level": "Master",
    "course": "Mathematics"
  },
  {
    "university": "University of Turin",
    "level": "Master",
    "course": "Artificial Intelligence and High Performance Computing Technologies"
  },
  {
    "university": "University of Florence",
    "level": "Master",
    "course": "Physical and Astrophysical Sciences"
  },
  {
    "university": "University of Venice",
    "level": "Master",
    "course": "Environmental Engineering for the Green Transition"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Chemical and Sustainable Processes Engineering 3 Curriculum 1. Biotechnological-food 2. Process design and development 3. Sustainability of processes and products in the chemical industry"
  },
  {
    "university": "University of Polito",
    "level": "Master",
    "course": "Electrical Engineering"
  },
  {
    "university": "University of Sapienza",
    "level": "Master",
    "course": "Telecommunication Engineering"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "Communication Engineering"
  },
  {
    "university": "University of Pisa",
    "level": "Master",
    "course": "DIGITAL INTELLIGENCE AND CHANGE MANAGEMENT"
  },
  {
    "university": "University of Polimi",
    "level": "Master",
    "course": "Architectural Engineering (Lecco)"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Languages for Global Business, Trade and Tourism"
  },
  {
    "university": "University of Verona",
    "level": "Master",
    "course": "Viticulture, enology and wine marketing"
  },
  {
    "university": "University of Messina",
    "level": "Master",
    "course": "Mechanical Engineering - Curriculum Mechanical Engineering and Innovation"
  },
  {
    "university": "University of Messina",
    "level": "Master",
    "course": "Global Security Studies"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Master",
    "course": "Mechanical Engineering for Energy and Environmental- Curriculum \"Sustainable Energy\""
  },
  {
    "university": "University of Parma",
    "level": "Master",
    "course": "Global food law: sustainability challenges and innovation"
  },
  {
    "university": "University of NAPLES \"Federico II\"",
    "level": "Master",
    "course": "Chemical Sciences"
  }
];

export const italyCourses = [
  ...italyBachelors,
  ...italyMasters,
];
